<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshTable"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="buildingForm">
        <el-select
          v-model="form.building"
          placeholder="请选择楼栋/单元"
          clearable
          @change="getTreeNode(4, form.building)"
          :disabled="buildingDisabled"
        >
          <el-option
            v-for="item in buildingList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="balance">
        <div>{{tool.money_format_allowvoid(scope.row.balance)}}</div>
      </template>

      <template slot-scope="scope" slot="roomIdForm">
        <el-select
          v-model="form.roomId"
          filterable
          @change="saveRoomId"
          placeholder="请选择房间"
          clearable
          :disabled="buildingDisabled"
        >
          <el-option v-for="item in roomList" :key="item.id" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkvehicle_delete"
          @click="handleDelete"
        >删 除
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-top"
          plain
          v-if="permissionList.syncBtn"
          @click="handleSync"
        >同步下发
        </el-button>

      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.charge"
          @click="openCarChargeDialog(scope.row)">
          充值
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.carNoChange"
          @click="openCarNoChargeDialog(scope.row)">
          车牌变更
        </el-button>
      </template>

    </avue-crud>
    <el-dialog
      title="充值"
      :visible.sync="chargeShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carChargeFormRef"
          v-model="carChargeForm"
          :option="carChargeOption"
          @close="quitCarChargeDialog"
          @submit="saveCarCharge"
        >
          <template slot="payMethod">

            <el-select
              v-model="carChargeForm.payMethod"
              @change="payTypeChange"
            >
              <el-option
                v-for="item in payTypeList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </template>
          <template slot="payScene">
            <el-select
              v-model="carChargeForm.payScene"
              @change="paySceneChange"
            >
              <el-option
                v-for="item in paySceneList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </template>
          <template slot="authCode">
            <!-- v-if="showAuthCodeFlag" -->
            <el-input type="password" ref="authCodeInput" v-model="carChargeForm.authCode" @blur="blurHandler" @input="inputHandler" @focus="focusHandler" maxlength="18" placeholder="请输入收款码"></el-input>
          </template>

          <template slot-scope="scope"  slot="balance">
            <div><moneyInput disabled v-model="carChargeForm.balance"></moneyInput></div>
          </template>
          <template slot-scope="scope"  slot="tradeFee">
            <div><moneyInput   v-model="carChargeForm.tradeFee"></moneyInput></div>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarChargeDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      :title="payScene==6?'查询中':'收款码'"
      :visible.sync="payInfo2.showQrCode"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode"
    >
      <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div id="qrcodeCar" ref="qrcode" style="display: inline-block"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>
    <carNoChange ref="carNoChange" @onLoad="onLoad"></carNoChange>
  </basic-container>
</template>

<script>
  import {
    add,
    getList,
    remove,
    update,
    syncVehicles,
    saveCarCharge,
    queryCarCharge,
    getPayMethods,
    getPaySceneList,
  } from '@/api/v4ward/park/vehicle/parkvehicle';
  import { getParkGroupList } from '@/api/v4ward/park/group/parkgroup';
  import { monthChargeRuleList } from '@/api/v4ward/car/carmonthchargerule';
  import { nodeTreeByParentId,loadCarPayAmount } from '@/api/v4ward/car/carmonth';
  import { driverSelections } from '@/api/v4ward/park/driver/parkdriver';
  import { loadRegionByParentId, getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import { mapGetters } from 'vuex';
  import addCarmonthOption from './parkvehicle-addCarmonth';
  import carChargeOption from './parkvehicle-carCharge';
  import { lazyBasePropertyTree, getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
  import { getDetailById as getCarParkspace } from '@/api/v4ward/car/carpark';
  import QRCode from "qrcodejs2";
  import {
    loadRoomTree1,
    loadBuildingList,
    loadRoomList,
    getArrearsExtendtion,
    getDict,
} from '@/api/charge/charge-pay';
import carNoChange from "./carNoChange.vue"
  export default {
    components:{carNoChange},
    data() {
      return {
        ruleDic: [],
        reWrite: false,
        spaceList: [],
        tempParkingLotId: '',
        firstDisplayFlag: false,
        buildingDisabled: true,
        buildingList: [],
        unitList: [],
        roomList: [],
        isaddCarMonthDialogFirstOpen: true,
        addCarMonthShowDialogFlag: false,
        addCarMonthForm: {
          spaceId: '',
          payMoney: '',
        },
        addCarmonthOption: addCarmonthOption,
        regionFirstIdTemp: '',
        addFlag: false,

        buyStartTimeTemp: '',
        buyEndTimeTemp: '',

        //充值配置
        chargeShowDialogFlag: false,
        payTypeList:[],
        paySceneList:[],
        showAuthCodeFlag: false,
        payInfo:{},
        payInfo2:{
          showQrCode:false,
          tradeStatus:'',
          countdown:'',
        },
        carChargeForm:{
          vehicleId:'',
          parkingLotId:'',
          parkingLotName:'',
          plateNumber:'',
          vehicleType:'',
          driverName:'',
          mobile:'',
          balance:'',
          tradeFee:'',
          payMethod:'',
          remark:'',
          payScene:'',
          authCode:'',
        },
        carChargeOption: carChargeOption,

        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        operateType: '',
        option: {
          height: 'auto',
          //calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          addBtn: false,
          viewBtn: true,
          menuWidth: 300,
          add_carMonthBtn: true,
          selection: true,
          dialogClickModal: false,
          labelWidth: 120,
          align: 'center',
          indexLabel: '序号',
          columnBtn: false,
          refreshBtn: false,
          column: [
            {
              // 用于搜索使用
              label: '车场名称',
              prop: 'parkingLotIdSearch',
              type: 'tree',
              display: false,
              hide: true,
              search: true,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
            },
            {
              label: '车场名称',
              prop: 'parkingLotId',
              type: 'select',
              editDisabled: true,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择车场',
                  trigger: 'change',
                },
              ],
              change: ({ value, column }) => {
                // 查询区域
                //this.loadRegion(value);
                // 加载收费规则
                this.loadRuleList(value);
                //加载车主
                this.loadDriverList(value);
                // 加载车辆分组
                // this.loadGroupList(value);
              },
            },
            {
              label: '车牌',
              prop: 'plateNumber',
              editDisabled: true,
              width: 100,
              search: true,
              rules: [
                {
                  required: true,
                  message: '请输入车牌',
                  trigger: 'blur',
                },
                {
                  required: true,
                  pattern: this.$validation.carPlate,
                  message: '车牌格式不对',
                  trigger: 'blur',
                },
              ],
            },
            {
              label: '车主',
              prop: 'driverId',
              type: 'tree',
              editDisabled: true,
              hide: true,
              editDisplay: false,
              viewDisplay: false,
              dicData: [],
              props: {
                label: 'label',
                value: 'value',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择车主',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车型',
              prop: 'vehicleType',
              type: 'select',
              width: 80,
              dataType: 'number',
              dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
              props: { label: 'dictValue', value: 'dictKey' },
              rules: [
                {
                  required: true,
                  message: '请选择车型',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车牌颜色',
              prop: 'plateColor',
              type: 'select',
              hide: true,
              editDisplay: false,
              dicUrl: 'api/blade-system/dict/dictionary?code=plate_color',
              props: { label: 'dictValue', value: 'dictValue' },
              rules: [
                {
                  required: true,
                  message: '请选择车牌颜色',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车辆品牌',
              prop: 'vehicleBrand',
              type: 'select',
              hide: true,
              editDisplay: false,
              dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_brand',
              props: { label: 'dictValue', value: 'dictValue' },
              rules: [
                {
                  required: false,
                  message: '请选择车辆品牌',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车身颜色',
              prop: 'vehicleColor',
              type: 'select',
              hide: true,
              editDisplay: false,
              dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_color',
              props: { label: 'dictValue', value: 'dictValue' },
              rules: [
                {
                  required: false,
                  message: '请选择车牌颜色',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车主',
              prop: 'driverName',
              maxlength: 10,
              viewDisplay: true,
              addDisplay: false,
              editDisplay: true,
              search: true,
              rules: [
                {
                  required: true,
                  message: '请输入车主姓名',
                  trigger: 'change',
                },
                {
                  min: 2,
                  max: 10,
                  message: '长度在2到10个字之间',
                  trigger: 'blur'
                }
              ],
            },
            {
              label: '手机号码',
              prop: 'mobile',
              addDisplay: false,
              rules: [
                {
                  required: true,
                  message: '请输入手机号码',
                  trigger: 'change',
                },
                {
                  required: true,
                  pattern: this.$validation.phone,
                  message: '请输入正确的手机号',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车主类型',
              prop: 'driverType',
              addDisplay: false,
              width: 80,
              type: 'select',
              rules: [
                {
                  required: true,
                  message: '请选择车主类型',
                  trigger: 'change',
                },
              ],
              dicData: [
                { label: '业主', value: 1 },
                { label: '非业主', value: 2 },
              ],
            },
            {
              hide: true,
              label: '楼栋/单元',
              prop: 'building',
              type: 'select',
              addDisplay: false,
              viewDisplay: false,
              formslot: true,
              search: false,
              rules: [],
            },
            // {
            //   hide: true,
            //   label: '单元名称',
            //   prop: 'unitName',
            //   type: 'select',
            //   addDisplay: false,
            //   viewDisplay: false,
            //   formslot: true,
            //   search: false,
            //   rules: [],
            // },
            {
              hide: true,
              label: '房间名称',
              prop: 'roomId',
              type: 'select',
              addDisplay: false,
              viewDisplay: false,
              formslot: true,
              search: false,
              rules: [],
            },
            {
              label: '房间',
              prop: 'roomName',
              width: 200,
              overHidden: true,
              addDisplay: false,
              editDisplay: false,
            },
            {
              label: '备注信息',
              prop: 'remark',
              span: 24,
              type: 'textarea',
              minRows: 2,
              maxlength: 100,
              hide: true,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: '余额',
              prop: 'balance',
              slot:true,
              span: 24,
              addDisplay: false,
              editDisabled: true,
            },
          ],
        },

        data: [],
      };
    },
    watch: {
      'form.driverType'() {
        this.changeSelectionStatus();
      },
      'form.parkingLotId'() {
        if (typeof this.form.parkingLotId !== 'undefined' && this.form.parkingLotId !== '') {
          //this.form.roomName = '';
          getCarParkspace({ id: this.form.parkingLotId }).then(({ data }) => {
            if(this.vdui.isNotEmpty(data.areaId)){
              loadBuildingList({propertyId:data.areaId}).then(res=>{
                this.buildingList = res.data;
              })
              // lazyBasePropertyTree(data.areaId).then((res) => {
              //   this.buildingList = res.data;
              // });
            }
          });
        }
      },
      'form.spaceId'() {
        this.form.ruleId = '';
        let spaceIdTem = this.form.spaceId;
        if (this.vdui.isNotEmpty(spaceIdTem)) {
          monthChargeRuleList(Object.assign({ spaceId: spaceIdTem })).then(({ data }) => {
            const column = this.findObject(this.option.column, 'ruleId');
            column.dicData = data;
          });

        }
      },
      'addCarMonthForm.cycleNum'() {
        this.initShoudMoney();
      },
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.parkvehicle_add, false),
          viewBtn: this.vaildData(this.permission.parkvehicle_view, false),
          delBtn: this.vaildData(this.permission.parkvehicle_delete, false),
          editBtn: this.vaildData(this.permission.parkvehicle_edit, false),
          syncBtn: this.vaildData(this.permission.parkvehicle_sync, false),
          charge: this.vaildData(this.permission.parkvehicle_charge, false),
          carNoChange: this.vaildData(this.permission.carNoChange, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    created() {
      getSpaceTree().then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {
          var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
          spaceColumn.dicData = data.data;

          // 搜索栏使用
          var spaceSearChColumn = this.findObject(this.option.column, 'parkingLotIdSearch');
          spaceSearChColumn.dicData = data.data;

          spaceSearChColumn.searchValue = this.spaceList[0].id;
          // 默认查询第一个
          this.query.parkingLotId = this.spaceList[0].id;
          this.tempParkingLotId = this.spaceList[0].id;
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
    },
    methods: {
      // 打开车牌变更弹窗
      openCarNoChargeDialog(row){
        this.$refs.carNoChange.openDialog(row)
      },
      changeSelectionStatus() {
        if (typeof this.form.driverType === 'undefined') {
          return;
        }
        //driverType = 1 ---业主，业主可以填房间信息
        this.buildingDisabled = this.form.driverType !== 1;

        let buildingColumn = this.findObject(this.option.column, 'building');
        let unitNameColumn = this.findObject(this.option.column, 'unitName');
        let roomIdColumn = this.findObject(this.option.column, 'roomId');
        if (this.form.driverType === 1) {
          //buildingColumn.editDisplay = true;
          buildingColumn.rules = [{ required: true, message: '请选择楼栋', trigger: 'change' }];
          unitNameColumn.rules = [{ required: true, message: '请选择单元', trigger: 'change' }];
          roomIdColumn.rules = [{ required: true, message: '请选择房间', trigger: 'change' }];
          //unitNameColumn.editDisplay = true;
          //roomIdColumn.editDisplay = true;
        } else {
          //buildingColumn.editDisplay = false;
          buildingColumn.rules = [];
          unitNameColumn.rules = [];
          roomIdColumn.rules = [];
          //unitNameColumn.editDisplay = false;
          //roomIdColumn.editDisplay = false;
        }

      },
      getTreeNode(type, id) {
        if(type==4){
            loadRoomList({ propertyId: id }).then(({ data }) => {
                console.log(data);
                this.form.roomId = '';
                this.roomList = data;

            });
        }else{
          loadRoomList({ propertyId: id }).then(({ data }) => {
                this.roomList = data;

            });
        }
        // getTreeChildrenPowerNode({
        //   object_type: type,
        //   id: id,
        // }).then((res) => {
        //   if (type == 1) {
        //   }else if (type == 4) {
        //     //单元下拉数据
        //     this.unitList = res.data;
        //     this.form.unitName = '';
        //     this.form.roomId = '';
        //     this.roomList = [];
        //   } else if (type == 6) {
        //     // this.propertyId_ = id;
        //     //房间下拉数据
        //     this.form.roomId = '';
        //     this.roomList = res.data;
        //   } else {
        //     this.form.building = '';
        //     this.form.unitName = '';
        //     this.form.roomId = '';
        //   }
        //   //this.$forceUpdate();
        // });
      },
      saveRoomId(e) {
        this.form.propertyId = e;
      },

      isEmpty(str) {
        return (!_.isNumber(str) && _.isEmpty(str)) || str === 'null' || str === 'undefined';
      },
      handleSync() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定下发所选车辆信息到对应车场终端?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return syncVehicles({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },


      // 加载车主主数据
      loadDriverList(parkId) {
        if(this.operateType === 'edit'){
          return;
        }
        const driverIdColumn = this.findObject(this.option.column, 'driverId');
        this.form.driverId = '';
        if (this.vdui.isNotEmpty(parkId)) {
          driverSelections({ id: parkId }).then((res) => {
            driverIdColumn.dicData = res.data;
          });
        } else {
          driverIdColumn.dicData = [];
        }
      },
      // 加载车辆分组
      loadGroupList(parkId) {
        const groupListColumn = this.findObject(this.option.column, 'groupList');
        this.form.groupList = '';
        if (this.vdui.isNotEmpty(parkId)) {
          getParkGroupList({ id: parkId }).then((res) => {
            groupListColumn.dicData = res.data;
          });
        } else {
          groupListColumn.dicData = [];
        }
      },
      rowSave(row, done, loading) {
        add(row).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
            done();
          },
          (error) => {
            window.console.log(error);
            loading();
          },
        );
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
            done();
          },
          (error) => {
            window.console.log(error);
            loading();
          },
        );
      },
      rowDel(row) {
        if(row.balance > 0){
          this.$message.warning('车辆【'+row.plateNumber+'】存在余额，不能删除！');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: row.id });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        //判断选中记录中余额是否为0
        this.selectionList.forEach(e=>{
          if(e){
            if(e.balance > 0){
              this.$message.warning('车辆【'+e.plateNumber+'】存在余额，不能删除！');
              return;
            }
          }
        });
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        this.operateType = type;
        if (['add'].includes(type)) {
          if (this.operateType === 'add') {
            //this.findObject(this.option.column, 'regionList').dicData = [];
            //this.findObject(this.option.column, 'setmealId').dicData = [];
            this.findObject(this.option.column, 'driverId').dicData = [];
            //this.findObject(this.option.column, 'groupList').dicData = [];

          }
        }
        if (['edit', 'view'].includes(type)) {
          this.form.building = this.form.buildingId;
          this.form.roomId = this.form.room;
          this.getTreeNode(5,this.form.building)
        }else {
          setTimeout(()=>{
            console.log(this.query.parkingLotId);
            this.form.parkingLotId = this.query.parkingLotId;
          },0);
        }
        done();
      },
      searchReset() {
        this.query = {};
        //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
        this.firstDisplayFlag = true;
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshTable() {
        this.onLoad();
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
        if (this.query.parkingLotIdSearch == undefined || this.query.parkingLotIdSearch == '') {
          this.query.parkingLotId = this.tempParkingLotId;
        } else {
          this.query.parkingLotId = this.query.parkingLotIdSearch;
        }
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="车场名称"]');
              ent.value = this.spaceList[0].title;
              this.query.parkingLotIdSearch = this.spaceList[0].id;
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          },
        );
      },

      //充值
      openCarChargeDialog(row){
        this.chargeShowDialogFlag = true;
        this.carChargeForm.tradeFee = row.tradeFee;
        this.carChargeForm.balance = row.balance;
        this.carChargeForm.driverName = row.driverName;
        this.carChargeForm.vehicleType = row.vehicleType;
        this.carChargeForm.parkingLotId = row.parkingLotId;
        this.carChargeForm.mobile = row.mobile;
        this.carChargeForm.parkingLotName = row.parkingLotName;
        this.carChargeForm.plateNumber = row.plateNumber;
        this.carChargeForm.vehicleId = row.id;
        this.carChargeForm.payMethod = "";
        this.carChargeForm.payScene = "";
        this.carChargeForm.tradeFee = "";
        getPayMethods().then((res)=> {
          this.payTypeList = res.data;
          let len = this.$refs.carChargeFormRef.columnOption[0].column.length;
          this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=false;
          this.$refs.carChargeFormRef.columnOption[0].column[len-3].display=false;
        });

      },
      quitCarChargeDialog(form,done){
        this.chargeShowDialogFlag = false;
        this.$refs.carChargeFormRef.resetForm();
      },
      saveCarCharge(form, done){
        if(parseInt(this.carChargeForm.payScene)==5){
          // 二维码
          this.qrCodePay();
        }else if(parseInt(this.carChargeForm.payScene)==6){
          // 扫码枪
          this.authCodePay();
        }else{
          // 现金
          this.normalPay();
        }
        done();
      },
      // 生成收款二维码
      qrCodePay(){
        saveCarCharge(this.carChargeForm, { showLoading: { text: '正在获取二维码' } }).then(
          (data) => {
            this.payInfo2.showQrCode = true;
            this.payInfo.payBillNo = data.data.orderNo;
            this.$nextTick(() => {
              new QRCode('qrcodeCar', {
                width: 250,
                height: 250,
                text: data.data.codeUrl,
              });
            });
            this.payInfo2.showQrCode = true;
            this.payInfo2.countdown = 120;
            this.payInfo2.timer = setInterval(() => {
              if (this.payInfo2.countdown === 0) {
                clearInterval(this.payInfo2.timer);
                this.payInfo2.showQrCode = false;
                this.$message.info('倒计时结束，二维码弹窗关闭');
              }
              if (this.payInfo2.countdown % 5 === 0) {
                queryCarCharge({ paybillNo: this.payInfo.payBillNo }).then(({ data }) => {
                  this.payInfo2.payStatus = data.tradeType;
                  if (parseInt(data.tradeType) == 2) {
                    this.payInfo2.showQrCode = false;
                    this.$message.success('支付成功');
                    this.isSuccess = true;
                    this.quitCarChargeDialog();
                    this.onLoad();
                    clearInterval(this.payInfo2.timer);
                  }
                });
              }
              this.payInfo2.countdown--;
            }, 1000);
          },
          (error) => {
            window.console.log(error);
          },
        );
      },
      authCodePay(){
        saveCarCharge(this.carChargeForm, { showLoading: { text: '正在付款中' } }).then(
          (data) => {
            this.payInfo.payBillNo = data.data.orderNo;
            this.openMaskAndPollingPayStatus();
            this.quitCarChargeDialog();
            this.onLoad();
            this.$message.success('操作成功!');
          },
          (error) => {
            window.console.log(error);
          },
        );
      },
      normalPay(){
        saveCarCharge(this.carChargeForm, { showLoading: { text: '处理中' } }).then(
          (data) => {
            this.payInfo.payBillNo = data.data.orderNo;
            this.quitCarChargeDialog();
            this.onLoad();
            this.$message.success('操作成功!');
          },
          (error) => {
            window.console.log(error);
          },
        )
      },
      resetAllData(){
        location.reload();
      },
      // 扫码枪轮询
      openMaskAndPollingPayStatus() {
        this.statusDuration = 120;
        this.statusDialogVisible = true;
        let timer = setInterval(() => {
          console.log('this.status==>', this.statusDuration);
          this.statusDuration--;
          console.log('this.status==>', typeof this.statusDuration);
          if (this.statusDuration <= 0) {
            this.$message.error('支付失败');
            this.statusDialogVisible = false;
            clearInterval(timer);
            this.statusDuration = 120;
            window.location.reload();
          } else {
            if (this.statusDuration % 10 == 0 || this.statusDuration == 119) {
              queryCarCharge({ paybillNo: this.payInfo.payBillNo }).then(({ data }) => {
                console.log('res pooling  data==>', data);
                if (parseInt(data.tradeType) == 2) {
                  this.payInfo2.payStatus = data.tradeType;
                  this.$message.success('支付成功');
                  this.statusDialogVisible = false;
                  clearInterval(timer);
                  this.statusDuration = 120
                }
              });
            }
          }
        }, 1000);
      },
      //关闭二维码
      closeQrCode() {
        setTimeout(() => {
          this.$refs.qrcode.innerHTML = '';
        }, 300);
        clearInterval(this.payInfo2.timer);
      },

      payTypeChange(val){
        if(val){
          this.carChargeForm.payScene = '';
          console.log(this.$refs.carChargeFormRef.columnOption[0]);
          let len = this.$refs.carChargeFormRef.columnOption[0].column.length;
          this.carChargeForm.payScene = '';
          if(parseInt(val)==4 || parseInt(val)==5 || parseInt(val)==6 || parseInt(val)==7){
            this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=false;
            this.showAuthCodeFlag = false;
            this.$refs.carChargeFormRef.columnOption[0].column[len-3].display=false;
          }else{
            this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=false;
            this.showAuthCodeFlag = true;
            this.$refs.carChargeFormRef.columnOption[0].column[len-3].display=true;
          }
          getPaySceneList({payMethod:val}).then((res)=>{
            this.paySceneList = res.data;
            console.log(res);
          });
        }
      },
      paySceneChange(val){
        let len = this.$refs.carChargeFormRef.columnOption[0].column.length;
        if(parseInt(val)==6){
          this.showAuthCodeFlag = true;
          this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=true;
        }else{
          this.showAuthCodeFlag = false;
          this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=false;
        }
      },
      blurHandler(){
        this.$refs.authCodeInput;
        this.carChargeForm.authCode
      },
      focusHandler(){
        console.log();
        this.$refs.authCodeInput;
        this.carChargeForm.authCode
        this.carChargeForm = Object.assign({},this.carChargeForm,{authCode:''});
      },
      inputHandler(val){
        this.$refs.authCodeInput;
        this.carChargeForm.authCode
      },
    },
  };
</script>

<style></style>
